import React from 'react';
import classes from './RedExclamationTooltip.module.scss';
import { IconsEnum } from '../../../constants/icons';
import { Icon } from '../../images/Icon/Icon';
import { Tooltip } from '../Tooltip';
import classNames from 'classnames';

export type RedExclamationTooltipViewProps = {
  id: string;
  title?: string;
  description: string | JSX.Element;
  moreInfoLink?: string;
  size: 'small' | 'medium' | 'large';
};

export const RedExclamationTooltipView = (props: RedExclamationTooltipViewProps): JSX.Element => {
  const { id, title, description, moreInfoLink, size } = props;

  const redExclamationTooltipClasses = classNames(classes.RedExclamationTooltip, {
    [classes[`RedExclamationTooltip${size}`]]: true
  });

  return (
    <div id={`RedExclamationWarning-${id}`} className={redExclamationTooltipClasses}>
      <Icon name={IconsEnum.exclamation} size={size} />
      <Tooltip
        type={'regular'}
        target={`#RedExclamationWarning-${id}`}
        pointer={true}
        position={'bottom'}
        autoHide={false}>
        <div>
          {title && <h5 style={{ color: 'white' }}>{title}</h5>}
          <div>{description}</div>
          {moreInfoLink && (
            <div className={'margin-top-small-8'}>
              <a href={'#'}>More Info</a>
            </div>
          )}
        </div>
      </Tooltip>
    </div>
  );
};
